export const getText = (type, item) =>{
    let data = {
        Online: "Programado",
        OnDemand: 'Ondemand',
        Cancelada: 'Cancelado',
        Pendiente: 'Pendiente',
        Pagada: "Programado",
        Reagendada: "Reagendada",
        NoAtendida: "No Atendida",
    }

    if(type==='Online' && item.appointment){
        return data[item.appointment.appointmentStatus] || ''
    }else if(type==="OnDemand"){
        return data[type]
    }else{
        return data[type] || ''
    }
}